import type { FullActivityItem } from '@customTypes/types';
import { Avatar, AvatarGroup, Box, Divider, Flex, Stack, Text } from '@mantine/core';

import { resolveImagePath } from '@/shared/helper';

export const TaskCard = ({ task, ...props }: { task: FullActivityItem }) => (
  <Box
    {...props}
    style={{
      padding: '12px',
      borderRadius: '8px',
      backgroundColor: 'rgba(255, 255, 255, 0.85)',
      backdropFilter: 'blur(8px)',
      border: '1px solid rgba(255, 255, 255, 0.6)',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.85)';
    }}
  >
    <Stack gap='xs'>
      <Flex align='center' gap='sm'>
        <AvatarGroup>
          <Avatar
            size={36}
            src={task.artistPhoto ? resolveImagePath(task.artistPhoto) : ''}
          />
          <Avatar
            size={36}
            src={task.clubPhoto ? resolveImagePath(task.clubPhoto) : ''}
          />
        </AvatarGroup>
      </Flex>
      <Divider />
      <Stack gap={4}>
        <Text c='dimmed' fw={500} size='xs'>
          Artist
        </Text>
        <Text fw={600} lineClamp={1} size='sm'>
          {task.artistName}
        </Text>
      </Stack>
      <Stack gap={4}>
        <Text c='dimmed' fw={500} size='xs'>
          Club
        </Text>
        <Text fw={600} lineClamp={1} size='sm'>
          {task.clubName}
        </Text>
      </Stack>
    </Stack>
  </Box>
);
